// import { useSelector } from "react-redux";
// import { LabelChart } from "../cmps/chart/label-chart";
// import { MemberChart } from "../cmps/chart/member-chart";


// export function Dashboard () {
//     // const board = useSelector(storeState => storeState.boardModule.board)
//     const grupos = useSelector( (storeState) => storeState.grupoModule.grupos );
//     const dynamicModalObj = useSelector(storeState => storeState.boardModule.dynamicModalObj)


//     const board = {
//         members: [
//             { _id: 'm1', fullname: 'Alice Johnson' },
//             { _id: 'm2', fullname: 'Bob Smith' },
//             { _id: 'm3', fullname: 'Charlie Brown' },
//             { _id: 'm4', fullname: 'Diana Prince' },
//         ],
//         groups: [
//             {
//                 groupName: 'Group 1',
//                 tasks: [
//                     { title: 'Task 1', memberIds: ['m1', 'm2'] },
//                     { title: 'Task 2', memberIds: ['m2', 'm3'] },
//                 ]
//             },
//             {
//                 groupName: 'Group 2',
//                 tasks: [
//                     { title: 'Task 3', memberIds: ['m1', 'm4'] },
//                     { title: 'Task 4', memberIds: ['m3'] },
//                 ]
//             }
//         ]
//     };
    

//     return (
//         <section className="dashboard">
//             <LabelChart board={grupos} dynamicModalObj={dynamicModalObj}/>
//             {/* <LabelChart board={board} dynamicModalObj={dynamicModalObj}/> */}
//             {/* <MemberChart board={board} dynamicModalObj={dynamicModalObj}/>
//             <MemberChart board={board} dynamicModalObj={dynamicModalObj}/> */}
//         </section>
//     )
// }


import { useSelector } from "react-redux";
import { useState } from "react";
import { LabelChart } from "../cmps/chart/label-chart";
import { MemberChart } from "../cmps/chart/member-chart";
import { Taskavancesgrafic } from "../cmps/chart/task-avances-grafic";
import { Graphicproject } from "../cmps/chart/project-avances_grafic";
import { Box, Grid, InputLabel, MenuItem, FormControl, Select } from '@mui/material';

export function Dashboard() {
  const grupos = useSelector((storeState) => storeState.grupoModule.grupos);
  const dynamicModalObj = useSelector((storeState) => storeState.boardModule.dynamicModalObj);

  // Estado para almacenar el grupo seleccionado
  const [selectedGroupId, setSelectedGroupId] = useState("all");

  // Maneja el cambio en el select
  const handleGroupChange = (event) => {
    setSelectedGroupId(event.target.value);
  };

  // Filtra los grupos según la selección
  const filteredGroups = selectedGroupId === "all" 
    ? grupos 
    : grupos.filter((group) => group.id_grupo === parseInt(selectedGroupId));

  return (
    <section className="dashboard">
    <Grid container spacing={2} direction="row">
      {/* Select para filtrar grupos */}
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel htmlFor="group-select">Filtrar por grupo:</InputLabel>
          <Select
            id="group-select"
            value={selectedGroupId}
            onChange={handleGroupChange}
            label="Filtrar por grupo"
          >
            <MenuItem value="all">Todos los grupos</MenuItem>
            {grupos.map((group) => (
              <MenuItem key={group.id_grupo} value={group.id_grupo}>
                {group.nombre_grupo}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
  
      {/* Componente LabelChart con los grupos filtrados */}
      <Grid item xs={6}>
        <Box sx={{ width: '80%', maxWidth: 800, margin: '0 auto' }}>
          <LabelChart board={filteredGroups} dynamicModalObj={dynamicModalObj} />
        </Box>
      </Grid>
  
      {/* Componente Taskavancesgrafic con los grupos filtrados */}
      <Grid item xs={6}>
        <Box sx={{ width: '80%', maxWidth: 800, margin: '0 auto' }}>
          {selectedGroupId !== "all" && (
            <Taskavancesgrafic board={filteredGroups} dynamicModalObj={dynamicModalObj} />
          )}
        </Box>
      </Grid>
    </Grid>
    <Grid container spacing={2} direction="column">

    <Grid item>
        <Box sx={{ width: '100%', maxWidth: 800, margin: '0 auto' }}>
        {selectedGroupId !== "all" && (
            <Graphicproject board={filteredGroups} dynamicModalObj={dynamicModalObj} />
          )}
        </Box>
      </Grid>
      </Grid>
  </section>


    
        


  );
}